import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAuthUser } from 'utils/auth';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

import Drawer from './Drawer';
import Header from './Header';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const location = useLocation();

  const isWastageRoute = location.pathname === '/wastage';
  const isBankTransactionRoute = location.pathname === '/bank-transaction-history';
  const isPosRoute = location.pathname === '/pos';

  const routeBgMap = {
  '/wastage': '#F8F9FA',
  '/petty-cash': '#F8F9FA'
};

const bgColor = routeBgMap[location.pathname] || 'transparent';

  // Sidebar: md (1024px) se upar permanent rahta he (page badalne par band nahi hota). Sirf bahut chhoti screen par overlay.
  // User ne jo last choice ki (open/mini) wo yaad rehti he; pehli baar lg (1266px) se upar open, us se neeche mini.
  useEffect(() => {
    if (downMD) {
      handlerDrawerOpen(false);
      return;
    }
    let saved = null;
    try {
      saved = localStorage.getItem('sidebar_open');
    } catch (e) {
      saved = null;
    }
    handlerDrawerOpen(saved === null ? !downLG : saved === '1');
  }, [downMD, downLG]);

  // Driver role: sirf My Trips. Kisi aur URL par jaye to wapis wahin (backend bhi baqi APIs par 403 deta hai).
  const isDriver = getAuthUser().role === 'driver';
  const onDriverPath = location.pathname.startsWith('/flour-mill/transport/trips');
  if (isDriver && !onDriverPath) return <Navigate to="/flour-mill/transport/trips" replace />;

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Header />
      <Drawer />

      {/* main: header ke neeche wali jagah. Scroll window par nahi, neeche wale content box me hota he,
          is liye scrollbar header ke neeche se shuru hota he. */}
      <Box
        component="main"
        sx={{
          width: 'calc(100% - 260px)',
          flexGrow: 1,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: bgColor
        }}
      >
        <Toolbar sx={{ mt: 'inherit', flexShrink: 0 }} />

        {/* scroll container */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            pt: isBankTransactionRoute || isPosRoute ? 0 : { xs: 2, sm: 2 },
            overflow: isPosRoute ? 'hidden' : 'auto',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              ...{ px: isBankTransactionRoute || isPosRoute ? 0 : { xs: 0, sm: 2 } },
              position: 'relative',
              ...(isPosRoute
                ? { flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }
                : { flex: '1 0 auto', minHeight: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column' })
            }}
          >
            <Outlet />
            {/* <Footer /> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}